import { HTMLProps, PureComponent } from 'react';
import classNames from 'classnames';
import { SpotFieldError } from './SpotFieldError';

export interface SpotRadioGroupProps {
    error?: any;
    isHorizontal?: boolean;
    title?: string;
}

export class SpotRadioGroup extends PureComponent<SpotRadioGroupProps & HTMLProps<HTMLFieldSetElement>> {
    render() {
        const { className, error, children, isHorizontal, title, ...rest } = this.props;
        return (
            <>
                <fieldset
                    className={classNames('spot-form__radio-group', { 'spot-form__field-group--horizontal': isHorizontal }, className)}
                    role="radiogroup"
                    {...rest}
                >
                    {Boolean(title) && <legend className="spot-form__radio-group-label">{title}</legend>}
                    <div className="spot-form__radio-group-inner">{children}</div>
                    {error && <SpotFieldError meta={error} />}
                </fieldset>
            </>
        );
    }
}
